export const SEARCH_DEBOUNCE_MS = 400;

export const RULE_STATUS_TABS = ['All', 'Active', 'Inactive'] as const;

export type RuleStatusTab = (typeof RULE_STATUS_TABS)[number];
